import baseApi from '@store/api/baseApi';

import { productWiseGroupDocument } from '@/store/actions/DesignToolAction';
import { toastError } from '@/components/Toast';

export const designToolApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getAiModel: builder.query({
			query: ({ productId }) => ({
				url: `/product-virtual-try-on/${productId}`,
				method: 'GET'
			})
		}),
		generateAiModel: builder.mutation({
			query: ({ data, productId }) => ({
				url: `/product-virtual-try-on/${productId}/generate-try-on`,
				method: 'POST',
				body: data
			})
		}),
		uploadModel: builder.mutation({
			query: ({ productId, data }) => ({
				url: `/product-virtual-try-on/${productId}/upload-try-on`,
				method: 'POST',
				body: data
			}),
			async onQueryStarted(_args, { queryFulfilled, dispatch }) {
				try {
					const { productId } = _args;
					await queryFulfilled;
					dispatch(productWiseGroupDocument(productId));
				} catch ({ error }) {
					toastError(error?.data?.message || 'Something went wrong');
				}
			}
		}),
		selectAiModel: builder.mutation({
			query: ({ productId, documentId }) => ({
				url: `/product-virtual-try-on/${productId}/default-image/${documentId}`,
				method: 'PUT'
			}),
			async onQueryStarted(_args, { queryFulfilled, dispatch }) {
				try {
					const { productId } = _args;
					await queryFulfilled;
					dispatch(productWiseGroupDocument(productId));
				} catch ({ error }) {
					toastError(error?.data?.message || 'Something went wrong');
				}
			}
		}),
		deleteAiModel: builder.mutation({
			query: ({ productId, documentId }) => ({
				url: `/product-virtual-try-on/${productId}/image/${documentId}`,
				method: 'DELETE'
			}),
			async onQueryStarted(_args, { queryFulfilled }) {
				try {
					await queryFulfilled;
				} catch ({ error }) {
					toastError(error?.data?.message || 'Something went wrong');
				}
			}
		})
	})
});

export const {
	useGetAiModelQuery,
	useGenerateAiModelMutation,
	useUploadModelMutation,
	useSelectAiModelMutation,
	useDeleteAiModelMutation
} = designToolApi;
